// Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved.

import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { ISecurityRequestResponse } from '../../../../../types/security-requests';
import { IVolume } from '../../../../../types/subscription';
import { TranslateService } from '@ngx-translate/core';
import { IVolumeConfigResponse } from '../../../../../types/drive';
import {
  MatSnackBar,
} from '@angular/material/snack-bar';
import { ClipboardService } from '../../../../../services/clipboard.service';

export interface IBitLockerDisplayDialogConfig {
  securityRequest: ISecurityRequestResponse;
  keyId: string;
  volume: IVolume;
  endpointName: string;
  volume_config: IVolumeConfigResponse
}

@Component({
    selector: 'app-bitlocker-display-key-dialog',
    templateUrl: './bitlocker-display-key-dialog.component.html',
    styleUrls: ['./bitlocker-display-key-dialog.component.scss'],
    standalone: false
})
export class BitlockerDisplayKeyDialogComponent {
  subTitle: string = '';

  constructor(private readonly dialogRef: MatDialogRef<IBitLockerDisplayDialogConfig>,
              private readonly translationService: TranslateService,
              private snackBar: MatSnackBar,
              private readonly clipboard: ClipboardService,
              @Inject(MAT_DIALOG_DATA) public data: IBitLockerDisplayDialogConfig) {
    this.subTitle = this.translationService.instant( 'endpoints.key_request.security_request_subtitle',
                                {'volume_name': this.data.volume.mount + " " + this.data.volume.label ,
                                                'endpoint_name': this.data.endpointName})
  }

  onButtonClick() {
        this.dialogRef.close(true);
  }

  onCopyBitlockerKey() {
    this.clipboard.copyMessage(this.data.volume_config.key,
      this.translationService.instant('endpoints.key_request.display_dialog.key_copied')).then(null);
  }

}
